// import 'react-app-polyfill/ie11'
// import 'react-app-polyfill/stable'
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './lib/Components/App'
import RecoveryPage from './RecoveryPage'
import ClearPage from './ClearPage'
import ReviewDashboardPage from './ReviewDashboard'
// import * as serviceWorker from './serviceWorker'
import 'isomorphic-fetch'
import { BrowserRouter, Route } from 'react-router-dom'

window.ondragover = function (e) {
    e.preventDefault()
    return false
}
window.ondrop = function (e) {
    e.preventDefault()
    return false
}

// ReactDOM.render(
//     // BrowserRouter allows the url path to define which behavior to use in the component
//     // :parameters can be accessed in the component App with this.props.match.params.parameter
//     // basename '/FormGeneric/' prepends all relevant paths in the project
//     <BrowserRouter basename="/FormGeneric/">
//         {/* Can only render 1 object. So, wrap everything in a div and render that. */}
//         <div>
//             <Route
//                 path="/form/:formId(\d+)/:customerAssetTypeID(\d+)/:serviceType([a-zA-Z]{1})"
//                 component={App}
//             />
//             <Route path="/form/:formType([a-zA-Z]+)" component={App} />
//             <Route path="/record/:recordId(\d+)" component={App} />
//             <Route path="/recoverRecord/:recoveryId(\d+)" component={App} />
//             <Route path="/recover" component={RecoveryPage} />
//             <Route path="/clear" component={ClearPage} />
//             <Route path="/review" component={ReviewDashboardPage} />
//         </div>
//     </BrowserRouter>,
//     // Parent element to fill up. Always present in index.html
//     document.getElementById('root')
// )

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister()
